export const animatedScrollTo = (elementY: number, duration = 500) =>
  new Promise((resolve) => {
    const startingY = window.pageYOffset;
    const diff = window.pageYOffset + elementY - startingY;
    let start: number | undefined;

    const step = (timestamp: number) => {
      if (!start) {
        start = timestamp;
      }
      const time = timestamp - start;
      const percent = Math.min(time / duration, 1);

      window.scrollTo(0, startingY + diff * percent);

      if (time < duration) {
        window.requestAnimationFrame(step);
      }
      if (time >= duration) {
        resolve(true);
      }
    };

    window.requestAnimationFrame(step);
  });
